
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M365.854 1000h268.292c119.978 0 226.466-57.752 293.183-146.973-109.9-106.271-259.573-171.668-424.526-171.668-166.572 0-317.566 66.685-427.755 174.808C141.902 943.6 247.291 1000 365.854 1000z","fill":"#f8cc61"}}),_c('path',{attrs:{"d":"M831.38 510.049h-89.4V706.25a87.669 87.669 0 01-87.669 87.669H351.31a87.669 87.669 0 01-87.669-87.669V510.05h-95.02L500 175.879z","fill":"#4d3d36"}}),_c('rect',{attrs:{"x":"408.929","y":"510.049","width":"187.748","height":"182.353","rx":"28.702","fill":"#f7f4e5"}}),_c('path',{attrs:{"d":"M625.38 222.124h52.38a28.702 28.702 0 0128.701 28.702v259.218H596.677V250.826a28.702 28.702 0 0128.702-28.702z","fill":"#4d3d36"}})])
          )
        }
      }
    